// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__d7AJ1","search":"Settings_search__2DF3g","filter":"Settings_filter__1Q72a"};